import React, { useState } from 'react';
import { ShoppingCart, Menu, X, LogOut, User, LogIn } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import Logo from '../shared/Logo';

export default function Header({ cartItemCount, onCartClick, onShowAuth, onSignout }) {
  const [showMenu, setShowMenu] = useState(false);
  const { currentUser } = useAuth();

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <button 
              onClick={() => setShowMenu(!showMenu)}
              className="md:hidden mr-4"
            >
              {showMenu ? <X size={24} /> : <Menu size={24} />}
            </button>
            <div className="flex items-center gap-2 cursor-pointer">
              <Logo />
              <h1 className="text-2xl font-bold text-red-600">MyMapleShop</h1>
            </div>
          </div>

          <nav className="hidden md:flex space-x-8 items-center">
            <button className="text-gray-700 hover:text-red-600 font-medium">Shop</button>
            <button className="text-gray-700 hover:text-red-600 font-medium">About</button>
            <button className="text-gray-700 hover:text-red-600 font-medium">Contact</button>
            
            {currentUser ? (
              <>
                <div className="flex items-center gap-2 text-gray-700">
                  <User size={18} />
                  <span className="font-medium">{currentUser.name}</span>
                </div>
                <button 
                  onClick={onSignout}
                  className="flex items-center gap-2 text-gray-700 hover:text-red-600 font-medium"
                >
                  <LogOut size={18} />
                  Sign Out
                </button>
              </>
            ) : (
              <button 
                onClick={onShowAuth}
                className="flex items-center gap-2 text-gray-700 hover:text-red-600 font-medium"
              >
                <LogIn size={18} />
                Sign In
              </button>
            )}
          </nav>

          <button 
            onClick={onCartClick}
            className="relative p-2 hover:bg-gray-100 rounded-lg"
          >
            <ShoppingCart size={24} />
            {cartItemCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-600 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                {cartItemCount}
              </span>
            )}
          </button>
        </div>

        {showMenu && (
          <div className="md:hidden py-4 border-t">
            <button className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100">Shop</button>
            <button className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100">About</button>
            <button className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100">Contact</button>
            
            {currentUser ? (
              <>
                <div className="px-4 py-2 text-gray-700 border-t mt-2">
                  <p className="font-medium">{currentUser.name}</p>
                  <p className="text-sm text-gray-500">{currentUser.email}</p>
                </div>
                <button 
                  onClick={onSignout}
                  className="block w-full text-left px-4 py-2 text-red-600 hover:bg-gray-100 font-medium"
                >
                  Sign Out
                </button>
              </>
            ) : (
              <button 
                onClick={onShowAuth}
                className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 font-medium"
              >
                Sign In
              </button>
            )}
          </div>
        )}
      </div>
    </header>
  );
}